module.exports = __webpack_public_path__ + "img/icons_27.19e907b1.png";